import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import useSWR from "swr";
import { BlogApiUrls } from "../../Api/Auth/ApiUrls";
import { noAuthfetcher } from "../../Api/swrConfig";
import HeroSection from "../../Components/Common/HeroSection";
import { Loader } from "../../Components/Common/Loader";
import NotFound from "../Notfound";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";

const FALLBACK_BACKGROUND =
  "https://storage.googleapis.com/road-to-fe/uploads/1741417535659-07d447cd-82a2-4b1b-8c08-9fffeaaefa18-colleagues-doing-team-work-project_23-2149361607.avif";

const BlogDetail = () => {
  const { slug } = useParams();
  const { data, error, isLoading } = useSWR(
    slug ? BlogApiUrls.single(slug) : null,
    noAuthfetcher
  );

  const descriptionHtml = useMemo(() => {
    const raw = data?.data?.description || "";
    return raw;
  }, [data]);

  const seoInfo = useMemo(() => {
    return {
      title: `${data?.data?.title || "Road to FE"} | RoadtoFE News & Insights`,
      description:
        "Stay informed with RoadtoFE's latest news, blog posts, and expert insights on FE exam preparation. Discover tips, updates, success stories, and more.",
      keywords: "FE exam blog, FE exam tips, FE exam news, RoadtoFE articles",
    };
  }, [data?.data?.title]);

  if (error) {
    if (error.response?.status === 404) {
      return <NotFound />;
    }
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-gray-600">
          Something went wrong while loading this blog.
        </p>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  const blog = data?.data;
  if (!blog) {
    return <NotFound />;
  }

  return (
    <div className="pb-12">
      <Helmet key={slug}>
        <title>{seoInfo.title}</title>
        <meta name="description" content={seoInfo.description} />
        <meta name="keywords" content={seoInfo.keywords} />
      </Helmet>
      <motion.div
        initial={{ opacity: 1, y: -40 }} // Start above the view
        whileInView={{ opacity: 1, y: 0 }} // End at normal position
        transition={{ duration: 1, ease: "easeOut" }} // Longer transition for more emphasis
      >
        <HeroSection
          title={blog.title}
          subtitle={blog.subtitle || ""}
          backgroundImage={FALLBACK_BACKGROUND}
        />
        <div className="gap-3 container mx-auto sm:mt-12 mt-4 flex justify-center md:justify-between items-start flex-wrap md:flex-nowrap px-2">
          <div
            className="prose max-w-none"
            dangerouslySetInnerHTML={{ __html: descriptionHtml }}
          />
          <div>
            <img
              src={data?.data?.link}
              alt="News"
              className="w-full h-72 object-cover rounded-md"
            />
          </div>
        </div>

        {/* <div className="container mx-auto mt-10 px-4">
          <div
            className="prose max-w-none"
            dangerouslySetInnerHTML={{ __html: descriptionHtml }}
          />
        </div> */}
      </motion.div>
    </div>
  );
};

export default BlogDetail;
